<template>
    <div id="main-video-section">
        <!--
        <video id="video-home-page" autoplay muted>
            <source src="@/assets/video/video_intro_ecole_oprod.mp4" type="video/mp4" />
        </video>
        -->
        <iframe id="video-home-page" src="https://www.youtube.com/embed/siyOvJW4xxM?autoplay=1&mute=1&controls=0"></iframe>
        
        <div id="main-app-access-container">
            <button id="main-app-access-button" type="button" @click="showMainApp">
                Site d'Origin's Prod's >>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MainVideo",
        title: 'Accueil - Origin\'s Prod\'s',
        methods: {
            showMainApp: function() {
                document.querySelector('#main-video-section').style.opacity = 0;
                setTimeout(() => { this.$emit('showMainPage'); }, 1500);
            }
        }
    }
</script>

<style lang="scss">
    #main-video-section {
        position: relative;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        background-color: black;
        display: flex;
        justify-content: right;
        align-items: flex-start;
        opacity: 1;
        transition: opacity 2s;
    }

    #video-home-page {
        z-index: 1;
        position: absolute;
        width: 100%;
        height: 120%;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    #main-app-access-container {
        z-index: 2;
    }

    #main-app-access-button {
        background: transparent;
        color: white;
        border: none;
        font-family: Ageo;
        font-size: 1rem;
        font-weight: 600;
    }

    #main-app-access-button:hover {
        border-bottom: 2px solid white;
    }
</style>